export const SOCIALS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/amiciperlamusica.aps',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/tms_amiciperlamusicaaps',
  },
  {
    id: 'whatsapp',
    label: 'Canale WhatsApp',
    href: 'https://whatsapp.com/channel/0029Vb96nYiBA1f6Acd5fM3s',
  },
];
